export { requireBiometricUnlock, getBiometryConsentInfo } from './biometricGate';
